import React, { useState, useRef, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Label } from "reactstrap";
import LocationNavigation from "@components/Locations/location-navigation";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import {
  clientCreateFunction,
  clientDeleteBulkFunction,
  clientGetFunction,
  clientUpdateSpecificFunction,
} from "@services/location.service";
import { getValue } from "@utils/lodash";
import Notfound from "@components/Not-Found";
import DeleteModal from "@_common/deleteModal";
import "./function.scss";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import PaginationPage from "@components/pagination/pagination";
import NoAccessPage from "@components/common/NoAccess";
import { sanitizeInput } from "@_common/dompurify";

interface ILocationFunctionProps {}

const LocationFunction: React.FunctionComponent<ILocationFunctionProps> = (
  props: any
) => {
  let orgParams = useParams();
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [function_name, setFunction_name] = useState("");
  const [unit_name, setUnit_name] = useState("");

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);
  useEffect(() => {
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      getData();
    }
  }, [props.permissionAPITriggered, window.location.href]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      location_id: orgParams.id,
    };
    let queryRequest = QueryRequestHelper(payload);
    setIsLoading(true);
    try {
      let resp = await clientGetFunction(queryRequest);
      if (resp) {
        setList(getValue(resp, `data.functions`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getDataRefetch = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      location_id: orgParams.id,
    };
    let queryRequest = QueryRequestHelper(payload);
    // setIsLoading(true);
    try {
      let resp = await clientGetFunction(queryRequest);
      if (resp) {
        setIsLoading(false);
        setList(getValue(resp, `data.functions`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      let payload = {
        function_name: function_name.trim(),
        unit_name: unit_name.trim(),
        location_id: orgParams.id,
      };
      try {
        if (edit) {
          let resp = await clientUpdateSpecificFunction(editId, payload);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            getDataRefetch();
            handleClear();
          }
        } else {
          let resp = await clientCreateFunction(payload);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            getDataRefetch();
            handleClear();
          }
        }
      } catch (error) {}
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await clientDeleteBulkFunction(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Edit section                               */
  /* -------------------------------------------------------------------------- */
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const handleEdit = (id: string, name: string, unit: string) => {
    setEdit(true);
    setEditId(id);
    setFunction_name(name);
    setUnit_name(unit);
  };

  const handleClear = () => {
    setEdit(false);
    setEditId("");
    setFunction_name("");
    setUnit_name("");
  };
  return (
    <Layout>
      <LocationNavigation id={orgParams.id} />
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "configuration_location"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="function-wrapper pt-5">
              <div className="function-wrapper__form d-flex justify-content-center">
                <div className="function-wrapper__form-group mb-3">
                  <Label className="function-wrapper__form-label">
                    Function Name
                  </Label>
                  <input
                    type="text"
                    placeholder={"Enter Function Name"}
                    className="function-wrapper__form-control form-control"
                    value={function_name}
                    onChange={(e: any) => setFunction_name(sanitizeInput(e.target.value))}
                    autoComplete="off"
                  />
                </div>
                <div className="function-wrapper__form-group mb-3">
                  <Label className="function-wrapper__form-label">
                    Unit Belongs To
                  </Label>
                  <input
                    type="text"
                    placeholder="Add Unit"
                    className="function-wrapper__form-control form-control"
                    value={unit_name}
                    onChange={(e: any) => setUnit_name(sanitizeInput(e.target.value))}
                    autoComplete="off"
                  />
                </div>
                <div className="function-wrapper__form-button">
                  {getValue(props, `permissions`, []).includes("create") && (
                    <button
                      className=" function-wrapper__button"
                      onClick={handleSubmit}
                    >
                      {edit ? "Update" : "Add"}
                    </button>
                  )}
                </div>
                <div className="function-wrapper__form-button">
                  {edit && (
                    <button
                      className=" function-wrapper__button"
                      onClick={handleClear}
                    >
                      {"Clear"}
                    </button>
                  )}
                </div>
              </div>
              <div className="function-wrappper__details">
                {list.length > 0 ? (
                  <>
                    <div className="function-wrapper__table w-100">
                      <div className="function-wrapper__table-head">
                        <ul>
                          <li>Function ID</li>
                          <li>Function Name</li>
                          <li>Unit Name</li>
                          <li></li>
                        </ul>
                      </div>
                      <div className="function-wrapper__table-body">
                        {list.map((item: object) => {
                          return (
                            <ul>
                              <li>{getValue(item, `function_id`, "")}</li>
                              <li>
                                <div className="function-wrapper__table-text">
                                  {getValue(item, `function_name`, "")}
                                </div>
                              </li>
                              <li>
                                {" "}
                                <div className="function-wrapper__table-text">
                                  {getValue(item, `unit_name`, "")}
                                </div>
                              </li>
                              {getValue(props, `permissions`, []).includes(
                                "delete"
                              ) && (
                                <li
                                  onClick={() =>
                                    handleDeleteFun(
                                      getValue(item, `id`, ""),
                                      getValue(item, `function_name`, "")
                                    )
                                  }
                                >
                                  <img
                                    src="/images/close-black.svg"
                                    className="img-fluid  cursor-pointer"
                                  />
                                </li>
                              )}
                              {getValue(props, `permissions`, []).includes(
                                "update"
                              ) && (
                                <li
                                  onClick={() =>
                                    handleEdit(
                                      getValue(item, `id`, ""),
                                      getValue(item, `function_name`, ""),
                                      getValue(item, `unit_name`, "")
                                    )
                                  }
                                >
                                  <img
                                    src="/images/edit.svg"
                                    style={{ height: "25px" }}
                                    className="img-fluid  cursor-pointer"
                                  />
                                </li>
                              )}
                            </ul>
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <>
                        <Notfound />
                      </>
                    ) : (
                      <Notfound />
                    )}
                  </>
                )}
              </div>
              {/* <div className="footer-wrapper-new w-100">
				<img
					src="/images/footer-image.svg"
					className="img-fluid footer-image"
				/>
			</div> */}
              <div className="d-flex justify-content-center">
                {list.length > 0 && (
                  <div className="function-wrapper__footer d-none">
                    <img src="/images/footer-image.svg" className="img-fluid" />
                  </div>
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
            </div>
          )}
        </>
      )}

      <DeleteModal
        isOpen={isDelete}
        handleModal={handleDelete}
        handleSubmit={handleDeleteFunction}
        deleteValue={deleteValue}
      />
    </Layout>
  );
};

export default LocationFunction;
